import { ConnectorEntity } from "@/domain/entities";
import { Connector } from "./Connector";

export class MonitoringInfo {
  connector_count: ConnectorCount;
  connector_list: Connector[];

  constructor(data: MonitoringInfoResponse) {
    this.connector_count = data.connector_count;
    this.connector_list = data.connector_list.map(
      (elem) => new Connector(elem as ConnectorEntity)
    );
  }
}

export type MonitoringInfoResponse = {
  connector_list: Pick<
    ConnectorEntity,
    "id" | "charger_id" | "status" | "charger"
  >[];
  connector_count: ConnectorCount;
};

type ConnectorCount = {
  available: number;
  in_use: number;
  unavailable: number;
};
